<template>
  <div class="app-calendar overflow-hidden border">
    <div class="row no-gutters">
      <!-- Sidebar -->
      <div
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{'show': isCalendarOverlaySidebarActive}">
        <calendar-sidebar @filter:author="filterAuthor" :scheduleAuthors="calendarAuthors" :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive" />
      </div>

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            <div class="position-relative">
              <!-- Loading discreto no centro superior -->
              <div v-if="isLoading" class="calendar-loading-discrete">
                <div class="d-flex align-items-center">
                  <div class="spinner-border spinner-border-sm text-primary mr-2" role="status">
                    <span class="sr-only">Carregando...</span>
                  </div>
                  <small class="text-muted">Carregando...</small>
                </div>
              </div>

            <full-calendar
              ref="refCalendar"
              :options="calendarOptions"
                class="full-calendar calendar-with-legend"
              />

              <!-- Legenda posicionada com CSS -->
              <div class="calendar-legend-overlay">
                <div class="d-flex justify-content-center align-items-center flex-wrap">
                  <span class="legend-badge mr-2" style="background: rgba(115, 103, 240, 0.15); color: #7367f0; padding: 2px 6px; border-radius: 10px; font-size: 0.7rem; font-weight: 600;">
                    ● Reunião
                  </span>
                  <span class="legend-badge mr-2" style="background: rgba(40, 199, 111, 0.15); color: #28c76f; padding: 2px 6px; border-radius: 10px; font-size: 0.7rem; font-weight: 600;">
                    ● Evento
                  </span>
                  <span class="legend-badge" style="background: rgba(255, 159, 67, 0.15); color: #ff9f43; padding: 2px 6px; border-radius: 10px; font-size: 0.7rem; font-weight: 600;">
                    ● Lembrete
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar Overlay -->
      <div
        class="body-content-overlay"
        :class="{'show': isCalendarOverlaySidebarActive}"
        @click="isCalendarOverlaySidebarActive = false"
      />
      <calendar-event-handler
        :key="handlerRenderKey"
        v-model="isEventHandlerSidebarActive"
        :event="{organizationalUnitsList: [], ...event}"
        :clear-event-data="clearEventData"
        @remove-event="promptRemoveEvent"
        @add-event="addEvent"
        @update-event="tryUpdateEvent"
        @change-confirmation="refetchEvents"
        @update-suggestion="updateLocalSuggestionData"
      />
    </div>
    <b-modal :ok-disabled="isEmpty(exclusionJustification)" @ok="removeEvent(eventToDelete)" title="Confirmar exclusão" ok-only id="delete-justification">
      <template #default>
        <b-form>
          <p class="pb-8">Justifique o motivo de exclusão deste agendamento.</p>
          <b-form-textarea :state="!isEmpty(exclusionJustification)" v-model="exclusionJustification"/>
        </b-form>
      </template>
      <template #modal-ok>
        Confirmar
      </template>
    </b-modal>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import store from '@/store/store'
import { onUnmounted } from '@vue/composition-api'
import calendarStoreModule from '@/views/apps/calendar/calendarStoreModule'
import CalendarSidebar from '@/views/apps/calendar/calendar-sidebar/CalendarSidebar.vue'
import CalendarEventHandler from '@/views/apps/calendar/calendar-event-handler/CalendarEventHandler.vue'
import useCalendar from '@/views/apps/calendar/useCalendar'
import {
  BModal,
  BFormTextarea,
  BForm,
} from 'bootstrap-vue'

export default {
  data: () => ({
    showDeleteJustificationDialog: false,
    promptEventId: null,
    fetchEventCount: 0,
    isLoading: false,
  }),
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    CalendarEventHandler,
    BModal,
    BFormTextarea,
    BForm
  },
  computed: {
    handlerRenderKey() {
      const eventId = this.event && this.event.id
      if (eventId) {
        return eventId
      } else return 'magic'
    },
    calendarAuthors() {
      return this.$store.getters['calendar/authors'] || []
    }
  },
  methods: {
    filterAuthor(email) {
      // Apenas atualizar o store - o refetch será disparado automaticamente
      // pelo watch no useCalendar.js, evitando chamadas duplas na API
      this.$store.dispatch('calendar/setAuthor', email)
    },
    tryUpdateEvent(eventData) {
      this.updateEvent(eventData).catch(
        error => this.showErrors(this, error, this)
      )
    },
    calculateCalendarAuthors(events) {
      if (events && this._.isArray(events) && events.length > 0) {

        const authors = (
          events.map(
            (eventApi) => {
              const props = eventApi.extendedProps
              if (props) {
                return {
                  value: props.author_email,
                  text: `${props.author_name} &lt;${props.author_email}&gt;`,
                  email: props.author_email
                }
              } else return {}
            }
          )
        )

        // authors.unshift({
        //   value: null,
        //   text: '',
        //   email: null
        // })

        this.$store.commit('calendar/ADD_AUTHORS', authors)
      } else return []
    },
    promptRemoveEvent(deletePayload) {
      this.eventToDelete = deletePayload

      this.showDeleteJustificationDialog = true

      this.$bvModal.show('delete-justification')
    },
    eventsFetched(events) {
      this.calendarAuthors = this.calculateCalendarAuthors(events)
      this.fetchEventCount++
      if (this.fetchEventCount === 2) {
        this.handleFirstEventFetch(events)
      }
      // Parar loading quando eventos são carregados
      this.isLoading = false
    },
    startLoading() {
      this.isLoading = true
    },
    stopLoading() {
      this.isLoading = false
    },
    handleFirstEventFetch(events) {

      this.$nextTick(() => {
        if (this._.isArray(events)) {
          const openEvent = events.findIndex((event) => {
            const scheduleEventId = this._.get(event, 'extendedProps.scheduleEventId')
            return scheduleEventId === this.promptEventId
          })

          if (openEvent !== -1) {
            this.event = events[openEvent]
            this.isEventHandlerSidebarActive = true
          }
        }
      })
    },
    updateLocalSuggestionData(index, data)
    {
      const path = 'extendedProps.suggestionDateList'
      const exists = this._.has(this.event, path)
      const list = this._.get(this.event, path)
      if ( exists && this._.isArray(list) ) {
        const suggestion = list[index]
        const payload = {...suggestion, ...data}
        this._.set(this.event, `${path}.${index}`, payload)
      }
    }
  },
  mounted() {
    const eventId = parseInt(_.get(this, '$router.currentRoute.query.e_id', null))
    this.promptEventId = eventId

    this.$on('fetched-events', this.eventsFetched)
    this.$on('loading-start', this.startLoading)
    this.$on('loading-end', this.stopLoading)
  },
  beforeDestroy() {
    this.$off('fetched-events', this.eventsFetched)
    this.$off('loading-start', this.startLoading)
    this.$off('loading-end', this.stopLoading)
  },
  setup(props, {emit}) {
    const CALENDAR_APP_STORE_MODULE_NAME = 'calendar'

    // Register module
    if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME)) store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME)
    })

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      eventToDelete,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      fetchEvents,
      refetchEvents,
      fetchCalendarTypes,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,

      exclusionJustification,

    } = useCalendar({emit})

    // const promptRemoveEvent = () => {

    // }

    fetchEvents()

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      eventToDelete,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      fetchCalendarTypes,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,

      exclusionJustification,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";

// CSS para posicionar a legenda logo após a toolbar do FullCalendar
.calendar-with-legend {
  .fc-header-toolbar {
    margin-bottom: 0.5rem !important; // Reduzir espaço após toolbar
  }
}

.calendar-legend-overlay {
  position: absolute;
  top: 40px; // Posicionar entre toolbar e cabeçalho do calendário
  left: 0;
  right: 0;
  z-index: 10;
  // Removido background, border e shadow
  padding: 2px 0; // Padding mínimo
  margin: 0; // Sem margem lateral

  // Garantir que não interfira com o calendário
  pointer-events: none;

  .legend-badge {
    pointer-events: auto; // Permitir interação com os badges se necessário
  }
}

// Loading discreto no centro superior
.calendar-loading-discrete {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);

  .spinner-border-sm {
    width: 1rem;
    height: 1rem;
  }

  small {
    font-size: 0.75rem;
    font-weight: 500;
  }
}

// Ajustar espaçamento do corpo do calendário para dar espaço para a legenda
.calendar-with-legend {
  .fc-view-harness {
    margin-top: 1.8rem !important; // Espaço para acomodar legenda entre toolbar e cabeçalho
  }
}

// Ajustes para telas muito grandes
@media (min-width: 1200px) {
  .calendar-legend-overlay {
    top: 45px; // Posição ajustada para telas muito grandes (proporcional ao desktop)
  }

  .calendar-with-legend {
    .fc-view-harness {
      margin-top: 2.0rem !important; // Ajustado proporcionalmente
    }
  }
}

// Responsividade
@media (max-width: 768px) {
  .calendar-legend-overlay {
    top: 85px; // Ajustar para mobile onde a toolbar pode ser mais alta
    padding: 3px 8px; // Padding adequado no mobile
    left: 1rem; // Alinhar com o padding do calendário
    right: 1rem; // Alinhar com o padding do calendário
    margin: 0; // Remover margem para usar left/right

    .d-flex {
      flex-direction: row; // Manter horizontal no mobile também
      align-items: center;
      justify-content: center;
      flex-wrap: wrap; // Permitir quebra de linha se necessário

      .legend-badge {
        font-size: 0.65rem; // Fonte menor no mobile
        padding: 2px 5px; // Padding adequado no mobile
        margin-right: 0.4rem; // Espaçamento entre badges
        margin-bottom: 2px; // Espaçamento vertical se quebrar linha
        white-space: nowrap; // Evitar quebra de texto
      }
    }
  }

  .calendar-loading-discrete {
    top: 6px; // Ajustar posição no mobile
    padding: 3px 10px; // Padding menor no mobile

    small {
      font-size: 0.7rem; // Fonte menor no mobile
    }
  }

  .calendar-with-legend {
    .fc-view-harness {
      margin-top: 2.5rem !important; // Mais espaço no mobile para acomodar legenda
    }
  }
}

// Ajustes para telas muito pequenas (smartphones)
@media (max-width: 480px) {
  .calendar-legend-overlay {
    top: 80px; // Posição entre toolbar e cabeçalho em telas pequenas
    padding: 2px 6px; // Padding ainda menor
    left: 0.5rem; // Alinhar com o padding do calendário em telas pequenas
    right: 0.5rem; // Alinhar com o padding do calendário em telas pequenas
    margin: 0; // Remover margem para usar left/right

    .d-flex {
      .legend-badge {
        font-size: 0.6rem; // Fonte ainda menor
        padding: 1px 4px; // Padding menor
        margin-right: 0.3rem; // Espaçamento menor
      }
    }
  }

  .calendar-loading-discrete {
    top: 4px; // Posição mais próxima
    padding: 2px 8px; // Padding menor

    small {
      font-size: 0.65rem; // Fonte menor
    }
  }

  .calendar-with-legend {
    .fc-view-harness {
      margin-top: 2.7rem !important; // Mais espaço para telas pequenas
    }
  }
}

// Ajustes para telas extra pequenas (smartphones antigos)
@media (max-width: 360px) {
  .calendar-legend-overlay {
    top: 75px; // Posição entre toolbar e cabeçalho em telas extra pequenas
    padding: 1px 4px; // Padding mínimo
    left: 0.25rem; // Alinhamento mais próximo das bordas
    right: 0.25rem; // Alinhamento mais próximo das bordas

    .d-flex {
      .legend-badge {
        font-size: 0.55rem; // Fonte muito pequena
        padding: 1px 3px; // Padding mínimo
        margin-right: 0.2rem; // Espaçamento mínimo
      }
    }
  }

  .calendar-loading-discrete {
    top: 3px; // Posição mais próxima
    padding: 2px 6px; // Padding menor

    small {
      font-size: 0.6rem; // Fonte menor
    }
  }

  .calendar-with-legend {
    .fc-view-harness {
      margin-top: 2.9rem !important; // Mais espaço para telas extra pequenas
    }
  }
}
</style>
